export const MARKETING_TAGS = {
    GOTO: 'GOTO',
    PRCD: 'PRCD',
    NEWV: 'NEWV',
};
//# sourceMappingURL=marketingTags.js.map